
import msgCfg from '@/config/msg.js';
import config from '@/config/config.js';
import api from '@/config/api_config.js';
import Cookies from 'js-cookie';
import axios from 'axios';
import { log } from 'util';
import gpsUtil from '@/common/gpsUtil.js';

let util = {
};

// 成功
util.success = function (val) {
    if (val === undefined || val === '' || val === null) {
        val = '成功！';
    }
    layui.use('layer', function () {
        layer.msg(val, { icon: 1, offset: config.layer.msg.top, time: config.layer.msg_timeout });
    });
};

// 失败
util.error = function (val) {
    if (val === undefined || val === '' || val === null) {
        val = '失败！';
    }
    layui.use('layer', function () {
        layer.msg(val, { icon: 2, offset: config.layer.msg.top, time: config.layer.msg_timeout });
    });
};

// 控制台输出
util.console = function (msg) {
    console.log(msg);
};

//初始化充电桩
util.initPileList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.piletype.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
}

// 初始化角色列表
util.initRoleList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.role.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
//初始化充电桩管理列表
util.initChargingList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.charge.listall, null, function (response) {
        response.data.messageList.forEach((item, index) => {
            res.push(item);
        })
    })
    return res;
};
// 初始化车牌号——车辆保险
util.initautoNo = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.auto.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};

// 初始化保险状态——车辆保险
util.initinsStatus = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.autoinsurance.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
//初始化RCS型号
util.initRCSTypeList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.rcstype.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};

//初始化充电桩型号
util.initPileTypeNoList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.piletype.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
}
//初始化RCS编码
util.initRCSCodeList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.rcs.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};

// 初始化公司列表
util.initCorpList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.corp.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
util.initCorps = function (vm) {
    let res = [];
    var mobile = Cookies.get('user');
    util.ajaxGet(vm, config.baseUrl + api.corp.findcorpbyphone + '/' + mobile,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};

//初始化公司列表第一个
util.getCorpListFirst = function (vm) {
    let res = '';
    util.ajaxPost(vm, config.baseUrl + api.corp.listall, null,
        function (response) {
            var corpNo = response.data.messageList["0"].corpNo;
            console.log(corpNo);
            return corpNo;
        });
};

// 初始化资费包列表
util.initProductList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.tariffgroup.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
// 初始化车辆电池管理列表
util.initAutoBatteryList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.autobattery.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
// 初始化费用列表
util.initFeeitemList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.feeitem.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                if (item.effectFlag == '01') {
                    res.push(item);
                }
            });
        });
    return res;
};
// 初始化站点列表
util.initRentalList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.rental.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
// 初始化发票列表
util.initInvsList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.inv.list, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};

// 初始化设备编号列表
util.initTerminalList = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.terminal.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                if (item.tmnlStatus == '01') {
                    res.push(item);
                }
            });
        });
    return res;
};

// 初始化所有配置
util.initSysconfigAll = function (vm, code, corpNo, afterFuc) {
    let res = [];
    var url = config.baseUrl + api.sysconfig.findbytype + '/' + code + '/' + corpNo;
    util.ajaxGet(vm, url,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                let codeType = item.codeType;
                let temp = {
                    codeValue: item.codeValue,
                    codeName: item.codeName,
                    codeContent1: item.codeContent1,
                    codeContent2: item.codeContent2,
                }
                if (!util.notNull(res[codeType])) {
                    res[codeType] = [];
                }
                res[codeType].push(temp);
            });
            afterFuc(res);
        });
    return res;
};
// 获取城市区县列表
util.initAreaList = function (vm) {
    util.ajaxGet(vm, config.baseUrl + api.area.listchild,
        function (response) {
            return response.data.messageList;
        });
};

// 初始化资费包（资费）列表--链接资费包
util.initgroupNo = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.tariffgroup.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                if (item.status == '02') {
                    res.push(item);
                }
            });
        });
    return res;
};

// 初始化费用代码（资费）列表--链接项目费用
util.inititemCode = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.feeitem.listitemCode, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};

// 初始化汽车型号--资费包界面使用
util.initautoModelArr = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.automodel.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
// 初始化车牌号--车辆电池管理界面使用
util.initlicenseNoArr = function (vm) {
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.auto.listall, null,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
        });
    return res;
};
//整数校验
util.validateIntVal = function (rule, value, callback, message) {
    if (value === '' || value === undefined) {
        callback(new Error(message));
    } else {
        if (!/^[0-9]+$/.test(value)) {
            callback(new Error(msgCfg.intVal));
        } else {
            callback();
        }
    }
};

// 登录
util.login = function (url, param, suc, err) {
    axios.post(url, param,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(function (response) {
            if (response.data.status === 200) {
                suc(response.headers.authorization);
            } else {
                err(response.data.messageList);
            }
            // suc(response.headers.authorization);
        }).catch(function (error) {
            err("系统内部错误！");
            //console.log(error.response.status);
        });
};

util.initRoute = function (otherRouter) {
    return otherRouter;
};

// 获取客户端ip
util.getLocalIp = function () {
    // return returnCitySN["cip"];
    return '';
}

// ajaxPost
util.ajaxPost = function (vm, url, param, suc, err) {
    axios.post(url, param,
        {
            headers: {
                'Content-Type': 'application/json',
                'authorization': Cookies.get('token')
            },
            timeout: config.ajax.timeout
        })
        .then(function (response) {
            if (response.status === 200 || response.data.status === 200) {
                if (response.data.status !== undefined && response.data.status !== 200) {
                    util.error(response.data.messageList[0].messageBody);
                    vm.showFix = false;
                    util.unMaskIt(vm.container);
                } else {
                    suc(response);
                }
            } else {
                util.error(response.data.messageList[0].messageBody);
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
        }).catch(function (error) {
            console.log(error);
            if (util.isContains(error.message, 'timeout') || error.response.status === 504) {
                util.error('请求超时');
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
            else if (error.response.status === 403) {
                // 跳转登录
                util.logout(vm);
            } else if (error.response.status === 500) {
                // 跳转登录
                util.error('服务器错误');
            }else {
                var msg = error.response.data.messageList[0].messageBody;
                if (util.notNull(msg)) {
                    util.error(msg);
                } else {
                    util.error(msgCfg.sysError);
                }
                vm.showFix = false;
                util.unMaskIt(vm.container);
                // util.error('系统异常，请稍后重试！');
            }
        });
};
// ajaxPost
util.ajaxPost2 = function (vm, url, param, suc, err) {
    axios.post(url, param,
        {
            headers: {
                'Content-Type': 'application/json',
                'authorization': Cookies.get('token')
            },
            timeout: config.ajax.timeout,
            responseType:'blob'
        })
        .then(function (response) {
            if (response.status === 200 || response.data.status === 200) {
                if (response.data.status !== undefined && response.data.status !== 200) {
                    util.error(response.data.messageList[0].messageBody);
                    vm.showFix = false;
                    util.unMaskIt(vm.container);
                } else {
                    suc(response);
                }
            } else {
                util.error(response.data.messageList[0].messageBody);
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
        }).catch(function (error) {
            console.log(error);
            if (util.isContains(error.message, 'timeout') || error.response.status === 504) {
                util.error('请求超时');
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
            else if (error.response.status === 403) {
                // 跳转登录
                util.logout(vm);
            } else {
                var msg = error.response.data.messageList[0].messageBody;
                if (util.notNull(msg)) {
                    util.error(msg);
                } else {
                    util.error(msgCfg.sysError);
                }
                vm.showFix = false;
                util.unMaskIt(vm.container);
                // util.error('系统异常，请稍后重试！');
            }
        });
};

// 传输文件
util.ajaxPostFile = function (vm, url, param, suc, err) {
    axios.post(url, param,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': Cookies.get('token')
            },
            timeout: config.ajax.exportTimeout,
        })
        .then(function (response) {
            if (response.status === 200 || response.data.status === 200) {
                if (response.data.status !== undefined && response.data.status !== 200) {
                    util.error(response.data.messageList[0].messageBody);
                    vm.showFix = false;
                    util.unMaskIt(vm.container);
                } else {
                    // console.log(response.data.messageList[0].messageId);

                    suc(response);
                }
            } else {
                util.error(response.data.messageList[0].messageBody);
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
        }).catch(function (error) {
            console.log(error);
            if (util.isContains(error.message, 'timeout') || error.response.status === 504) {
                util.error('请求超时');
                console.log(config.ajax.exportTimeout);
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
            else if (error.response.status === 403) {
                // 跳转登录
                util.logout(vm);
            } else {
                var msg = error.response.data.messageList[0].messageBody;
                if (util.notNull(msg)) {
                    util.error(msg);
                } else {
                    util.error(msgCfg.sysError);
                }
                vm.showFix = false;
                util.unMaskIt(vm.container);
                // util.error('系统异常，请稍后重试！');
            }
        });
};

// 排序参数
util.compare = function (property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    };
};
// 排序参数
util.compareDate = function (property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return new Date(value1) - new Date(value2);
    };
};


// 将数组转为逗号分隔的字符串
util.parseArrToStr = function (arr) {
    let str = '';
    arr.forEach((item) => {
        str = str + ',' + item;
    });
    return str.substr(1);
};

// 登出
util.logout = function (vm) {
    if (util.notNull(vm) && util.notNull(vm.$router)) {
        // 清除token
        Cookies.remove('currUserName');
        Cookies.remove('currCorpSysId');
        Cookies.remove('currCorpNo');
        Cookies.remove('currCorpName');
        Cookies.remove('currCorpId');
        Cookies.remove('user');
        Cookies.remove('userPwd');
        Cookies.remove('userIp');
        Cookies.remove('token');
        vm.$router.push({
            name: 'login'
        });
    }
};

// ajaxGet
util.ajaxGet = function (vm, url,suc, timeout) {
    if (!util.notNull(timeout)) {
        timeout = config.ajax.timeout;
    }
    axios.get(url, {
        headers: {
            'Content-Type': 'application/json',
            'authorization': Cookies.get('token')
        },
        timeout: config.ajax.timeout,
    })
        .then(function (response) {
            if (response.status === 200 || response.data.status === 200) {
                if (response.data.status !== undefined && response.data.status !== 200) {
                    util.error(response.data.messageList[0].messageBody);
                    vm.showFix = false;
                    util.unMaskIt(vm.container);
                } else {
                    suc(response);
                }

            } else {
                util.error(response.data.messageList[0].messageBody);
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
        }).catch(function (error) {
            if (util.isContains(error.message, 'timeout') || error.response.status === 504) {
                util.error('请求超时');
                vm.showFix = false;
                util.unMaskIt(vm.container);
            } else if (error.response.status === 403) {
                // 跳转登录
                util.logout(vm);
            } else {
                var msg = error.response.data.messageList[0].messageBody;
                if (util.notNull(msg)) {
                    util.error(msg);
                } else {
                    util.error(msgCfg.sysError);
                }
                vm.showFix = false;
                util.unMaskIt(vm.container);
                // util.error('系统异常，请稍后重试！');
            }
        });
};

// ajaxGetParam
util.ajaxGetParam = function (vm, url, param, suc, timeout) {
    if (!util.notNull(timeout)) {
        timeout = config.ajax.timeout;
    }
    axios.get(url, {
        headers: {
            'Content-Type': 'application/json',
            'authorization': Cookies.get('token')
        },
        params: param || {},
        timeout: config.ajax.timeout,
    })
        .then(function (response) {
            if (response.status === 200 || response.data.status === 200) {
                if (response.data.status !== undefined && response.data.status !== 200) {
                    util.error(response.data.messageList[0].messageBody);
                    vm.showFix = false;
                    util.unMaskIt(vm.container);
                } else {
                    suc(response);
                }

            } else {
                util.error(response.data.messageList[0].messageBody);
                vm.showFix = false;
                util.unMaskIt(vm.container);
            }
        }).catch(function (error) {
            if (util.isContains(error.message, 'timeout') || error.response.status === 504) {
                util.error('请求超时');
                vm.showFix = false;
                util.unMaskIt(vm.container);
            } else if (error.response.status === 403) {
                // 跳转登录
                util.logout(vm);
            } else {
                var msg = error.response.data.messageList[0].messageBody;
                if (util.notNull(msg)) {
                    util.error(msg);
                } else {
                    util.error(msgCfg.sysError);
                }
                vm.showFix = false;
                util.unMaskIt(vm.container);
                // util.error('系统异常，请稍后重试！');
            }
        });
};

// 排序
util.sortList = function (key, val) {
    var map = {
        sortkey: key,
        sortvalue: val
    };
    return map;
};

// 时间校验
util.timeCheck = function (rule, value, callback) {
    if (value === ' ' || value === '' || value === undefined) {
        callback(new Error(msgCfg.selectDateInput));
    } else {
        callback();
    }
};

// 去空格
util.trim = function (str) {
    return str.replace(/^\s+|\s+$/gm, '');
};

// 初始化面包屑路径
util.initBcPath = function (vm, secName, third, fourthName) {
    vm.$store.state.bcArr.secondTitle = secName;
    if (false !== third) {
        vm.$store.state.bcArr.thirdTitle = third.title;
        vm.$store.state.bcArr.thirdName = third.name;
    } else {
        vm.$store.state.bcArr.thirdTitle = false;
        vm.$store.state.bcArr.thirdName = false;
    }
    vm.$store.state.bcArr.fourthTitle = fourthName;
};

// 文件
util.saveExcelFile = function (data) {
    var filePath = data.filePath;
    // 判断空
    if (util.isEmpty(filePath)) return;

    var bin = atob(data.base64.replace(/\s/g, ''));
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }

    var blob = new Blob([buffer.buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // 输出文件
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filePath);
    } else {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.target = '_blank';
        a.download = filePath;
        a.click();
        URL.revokeObjectURL(a.href);
    }
};

// 判断对象为空
util.isEmpty = function (str) {
    if (str === '' || str === undefined || str === null) {
        return true;
    }
    return false;
};

// 字符串包含
util.isContains = function (str, substr) {
    return str.indexOf(substr) >= 0;
}


// 获取配置项
util.getConfig = function (vm, code) {
    let res = [];
    var url = config.baseUrl + api.sysconfig.findbytype + '/' + code;
    util.ajaxGet(vm, url,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                let temp = {
                    codeName: item.codeName,
                    codeValue: item.codeValue
                };
                res.push(temp);
            });
        });
    return res;
};
// 获取页面全部配置项
util.getAllConfig = function (vm, code, afterFuc) {
    let res = [];
    var url = config.baseUrl + api.sysconfig.findbytype + '/' + code ;
    // var url = config.baseUrl + api.sysconfig.findbytype + '/' + code + '/' + corpNo;
    util.ajaxGet(vm, url,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                let codeType = item.codeType;
                let temp = {
                    codeType: item.codeType,
                    codeName: item.codeName,
                    codeValue: item.codeValue
                };
                if (!util.notNull(res[codeType])) {
                    res[codeType] = [];
                }
                res[codeType].push(temp);
            });
            afterFuc(res);
        });
};
//获取配置状态
util.getStatus = function (vm, code) {
    let res = [];
    var url = config.baseUrl + api.sysconfig.findbytype + '/' + code;
    util.ajaxGet(vm, url,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                let temp = {
                    codeName: item.codeName,
                    codeValue: item.codeValue
                };
                res.push(temp);
            });
        });
    return res;
};
// 处理级联列表
util.getMessages = function (vm, code, numd) {
    let res = [];
    var url = config.baseUrl + api.sysconfig.findbytype + '/' + code;
    util.ajaxGet(vm, url,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                if (item.codeValue.length === numd) {
                    let temp = {
                        label: item.codeName,
                        value: item.codeValue,
                        children: []
                    };
                    res.push(temp);
                }
            });
        });
    return res;
};

// 获取配置项列表
util.getConfigList = function (vm, code, fn) {
    let res = [];
    var url = config.baseUrl + api.sysconfig.findbytype + '/' + code;
    util.ajaxGet(vm, url,
        function (response) {
            response.data.messageList.forEach((item, index) => {
                res.push(item);
            });
            if (util.notNull(fn)) {
                fn();
            }
        });
    return res;
};

// List watch route 通用方法
util.initListRoute = function (vm) {
    vm.selections = []; //选择重置
    vm.searchVal = '';
};

// 格式化时间
util.formatTime = function (date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();;
    var second = date.getSeconds();

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
};
//格式化时间（前一天）
util.yesterday = function (date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate()-1;
    var hour = date.getHours();
    var minute = date.getMinutes();;
    var second = date.getSeconds();

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
};

util.toTimeStamp = function (date) {
    if (!util.notNull(date)) {
        return '';
    }
    let unix = Date.parse(new Date(date));
    let unixTimestamp = new Date(unix)
    let Y = unixTimestamp.getFullYear()
    let M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
    let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
    let toDay = Y + '-' + M + '-' + D
    return toDay + ' 00:00:00';
};

util.toCrrTimeStamp = function (date) {
    if (!util.notNull(date)) {
        return '';
    }
    let unix = Date.parse(new Date(date));
    let unixTimestamp = new Date(unix)
    let Y = unixTimestamp.getFullYear()
    let M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
    let D = (unixTimestamp.getDate() > 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
    let H = unixTimestamp.getHours()
    H = H < 10 ? ('0' + H) : H
    let i = unixTimestamp.getMinutes()
    i = i < 10 ? ('0' + i) : i
    let s = unixTimestamp.getSeconds()
    s = s < 10 ? ('0' + s) : s
    let dateRes = Y + '-' + M + '-' + D + ' ' + H + ':' + i + ':' + s;
    return dateRes;
};


// 将经纬度补全为6位
util.updateToLonLat = function (val) {
    if (!util.notNull(val)) {
        return 0;
    }
    var num = parseFloat(val);
    if (num <= 0) {
        return 0;
    }
    return num.toFixed(6);
};
// 总电压总电流控制到小数点一位
util.updateVal = function (val) {
    if (!util.notNull(val)) {
        return 0;
    }
    var num = parseFloat(val);
    if (num <= 0) {
        return 0;
    }
    return num.toFixed(1);
};
// 速度和SOC控制在整数格式
util.updateIntVal = function (val) {
    if (!util.notNull(val)) {
        return 0;
    }
    var num = parseFloat(val);
    if (num <= 0) {
        return 0;
    }
    return num.toFixed(0);
};
// 资金列表订单金额显示正数
util.updateVal = function (val) {
    if (!util.notNull(val)) {
        return 0;
    }
    var num = parseFloat(val);
    if (num <= 0) {
        return -num;
    }
    return num.toFixed(2);
};
// GPS---高德
util.getGdGps = function (lon, lat) {
    // console.log('getGdGps经纬度'+lon+';'+lat);
    lon = util.updateToLonLat(lon);
    lat = util.updateToLonLat(lat);
    var gps = gpsUtil.gcj_encrypt(parseFloat(lat), parseFloat(lon));
    // console.log(gps);
    var res = {
        lon: parseFloat(util.updateToLonLat(gps.lon)),
        lat: parseFloat(util.updateToLonLat(gps.lat)),
    };
    return res;
};

// 高德---GPS
util.getGps = function (lon, lat) {
    // console.log('getGps经纬度'+lon+';'+lat);
    lon = util.updateToLonLat(lon);
    lat = util.updateToLonLat(lat);
    var gps = gpsUtil.gcj_decrypt(parseFloat(lat), parseFloat(lon));
    // console.log(gps);
    var res = {
        lon: parseFloat(util.updateToLonLat(gps.lon)),
        lat: parseFloat(util.updateToLonLat(gps.lat)),
    };
    return res;
};

util.toUnix = function (date) {
    if (!util.notNull(date)) {
        return 0;
    }
    let unix = Date.parse(new Date(date));
    return unix;
};

// 获取当前的时间戳 毫秒值
util.getCurrUnix = function () {
    return new Date().getTime();
};

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
};

// 判断对象非空
util.notNull = function (obj) {
    if (obj !== '' && obj !== ' ' && obj !== undefined && obj !== null) {
        return true;
    }
    return false;
};

//数值转化为百分比
util.parsePercent = function (val) {
    val = val * 100;
    return parseFloat(val.toFixed(2));
};

// 初始化系统配置列表
util.getAllSysCfgs = function (vm) {
    var postParam = {
        pageSize: 9999,
        pageNum: 0
    };
    let list = {};
    let res = [];
    util.ajaxPost(vm, config.baseUrl + api.sysconfig.list, JSON.stringify(postParam),
        function (response) {
            response.data.messageList.content.forEach((item, index) => {
                if (!util.notNull(list[item.codeTypeName])) {
                    res.push(item);
                    list[item.codeTypeName] = 1;
                }
            });
        });
    return res;
};

// 添加遮罩
util.maskIt = function (obj) {
    var height = $(obj).height();
    var hoverdiv = '<div class="divMask" style="position: absolute; width: 100%; height: ' + height + 'px; overflow:hidden; left: 0px; top: 0px; background: #EEEEEE;opacity: 0.5; filter: alpha(opacity=40);z-index:5;"></div>';
    $(obj).wrap('<div class="position:relative;"></div>');
    $(obj).before(hoverdiv);
    $(obj).data("mask", true);
};

// 去除遮罩
util.unMaskIt = function (obj) {
    if ($(obj).data("mask") == true) {
        $(obj).parent().find(".divMask").remove();
        $(obj).unwrap();
        $(obj).data("mask", false);
    }
    $(obj).data("mask", false);
};
// 弹出div
// util.alertDiv = function(obj,flag,click){
//     var coverdiv = '<div class="fade" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.5);position: fixed;left: 0;top: 0;z-index: 99;"></div>';
//     $(obj).css({
//         'position' :'fixed',
//         'left' :'50%',
//         'top' :'20%',
//         'z-index': '999',
//         'display':'block',
//         'transform': 'translate(-50%,-50%)'
//     });
//     $(obj).parent().find(".fade").click(function(){
//         alert(2);
//         $(obj).css({
//             'display':'none',
//         });
//     });
//     $(obj).before(coverdiv);
//     $(obj).data("mask", true);
// };
var layerLoad = '';
// 加载中
util.startLoad = function (vm) {
    layui.use('layer', function () {
        layerLoad = layer.load(1, { offset: config.layer.load.top });
    });
};

util.closeLoad = function (vm) {
    layui.use('layer', function () {
        layer.close(layerLoad);
    });
};

util.checkDayTime = function (time1, time2) {
    time1 = Date.parse(time1) / 1000;
    time2 = Date.parse(time2) / 1000;
    var time_ = time2 - time1;
    return (time_ / (3600 * 24));
};

// 保留两位小数
util.toNum2 = function (val) {
    if (util.notNull(val)) {
        val = parseFloat(val);
        var f = Math.round(val * 100) / 100;
        return f;
    } else {
        return 0;
    }
};

// 根据距离计算缩放
util.getZoomByDis = function (dis) {
    if (dis < 2)
        return 14;
    if (dis < 3)
        return 14;
    if (dis < 10)
        return 13;
    if (dis < 18)
        return 11;
    if (dis < 30)
        return 10;
    if (dis < 60)
        return 9;
    if (dis < 90)
        return 8;
    if (dis < 180)
        return 7;
    if (dis < 300)
        return 6;
    return 5;
};

export default util;

